export default {
	title: 'Kontakty',
	client: 'Klient',
	surname: 'Příjmení klienta',
	name: 'Jméno klienta',
	businessName: 'Název',
	personIn: 'Rodné číslo', // RČ
	businessIn: 'IČO',
	zipCode: 'PSČ',
	municipality: 'Obec',
	street: 'Ulice',
	policyNo: 'Číslo PS',
	proposalNo: 'Číšlo návrhu PS',
	product: 'Produkt',
	solutionState: 'Stav kontaktu',
	campaign: 'Kampaň',
	search: 'Vyhledat',
	report: 'Report',
	sellerName: 'Přiděleno na',
	city: 'Město',
	phone1: 'Telefon 1',
	phone2: 'Telefon 2',
	email: 'Email',
	production: 'Produkce',
	takeContact: 'Převzetí kontaktu',
	regular_insurance: 'BP',
	single_insurance: 'JP',
	paired: 'Spárováno',
	notPaired: 'Nespárováno',
	contractEndDate: 'Konec smlouvy',
	date: 'Datum',
	tooManyContactsForPrint:
		'Nelze vytisknout více, než 50 kontaktů. Zpřesněte filtrační kritéria a pokuste se tisk opakovat.',
	bruttoProductionPaired: 'Spárovaná produkce',
	bruttoProductionNotPaired: 'Nespárovaná produkce',
};
